import { Action } from '@ngrx/store';
import { AlertType } from '../../../../../core/model';

export enum AlertsActionTypes {
  DismissAlert = '[Alerts] Dismiss alert',
  SetAlert = '[Alerts] Set alert',
  ClearAlert = '[Alerts] Clear alert',
  ClearAlertDelayed = '[Alerts] Clear alert delayed',
  ClearAllAlerts = '[Alerts] Clear all alerts',
}

export class DismissAlert implements Action {
  readonly type = AlertsActionTypes.DismissAlert;

  constructor(
    public payload: {
      type: AlertType;
      reappearable: boolean;
      messageHash: string;
    }
  ) {}
}

export class SetAlert implements Action {
  readonly type = AlertsActionTypes.SetAlert;

  constructor(
    public payload: {
      type: AlertType;
      dismissed: boolean;
      reappearable: boolean;
      messageHash: string;
    }
  ) {}
}

export class ClearAlert implements Action {
  readonly type = AlertsActionTypes.ClearAlert;

  constructor(
    public payload: {
      type: AlertType;
    }
  ) {}
}

export class ClearAlertDelayed implements Action {
  readonly type = AlertsActionTypes.ClearAlertDelayed;

  constructor(
    public payload: {
      type: AlertType;
    }
  ) {}
}

export class ClearAllAlerts implements Action {
  readonly type = AlertsActionTypes.ClearAllAlerts;
}

export type AlertsActions = DismissAlert | SetAlert | ClearAlertDelayed | ClearAlert | ClearAllAlerts;
